"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var ExitFullscreenIcon = function ExitFullscreenIcon(_a) {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M8.51,1.512l0.002,4.861c0.157,1.139,1.15,1.139,1.628,1.139h4.349v-1h-4.274l3.626-3.645l-0.709-0.705L9.508,5.805 L9.51,1.512H8.51z"
  }), React.createElement("path", {
    d: "M5.783,9.508l-3.631,3.614l0.705,0.709l3.628-3.611l0,4.269h1l-0.001-4.31C7.55,9.19,7.167,8.631,6.277,8.512L1.511,8.515 l0.001,1L5.783,9.508z"
  }))));
};

exports["default"] = ExitFullscreenIcon;